// export const ROUND_SERVER = "http://localhost:3001"

//Heroku based server
export const ROUND_SERVER = "https://leap-round-generator.herokuapp.com";

export const DEBUG = true
